import parse from 'html-react-parser';
import { FC } from 'react';
import style from './roadServiceTermsPopupStyle.module.css';
import { RoundSheet } from '@/components/uiParts/Sheet/RoundSheet/RoundSheet';

interface RoadServiceTermsPopupProps {
  html?: string;
}
export const RoadServiceTermsPopup: FC<RoadServiceTermsPopupProps> = ({
  html,
}) => {
  if (!html) return <></>;
  return (
    <RoundSheet>
      <div className={style['container']}>{parse(html)}</div>
    </RoundSheet>
  );
};
